import { createStore } from "vuex";
import repoStore from "@/src/store/modules/repoStore";
import graphStore from "@/src/store/modules/graphStore";
import userStore from "@/src/store/modules/userStore";
import chatbotStore from "@/src/store/modules/chatbotStore";
import graphWizardStore from "./modules/graphWizardStore";
import connectionStore from "./modules/connectionStore";

// The store holds client state only. Anything that just called an endpoint now lives in
// `src/api`, and cached server data lives in the query cache (`src/queries`).
const store = createStore({
  modules: {
    repoStore,
    graphStore,
    chatbotStore,
    userStore,
    graphWizardStore,
    connectionStore
  },
});

// export the store
export default store;
